import { DSNCAuthorOpinion } from 'shared-definitions/types'
import styleUtils from 'shared-components/styles/util.module.css'
import clsx from 'clsx'
import styles from './NCAuthorOpinion.module.css'
import AppImage from '../ui/AppImage'
import NumberInfoIcon from '../service/NumberInfoIcon'

interface NCAuthorOpinionProps {
  data: DSNCAuthorOpinion
}

const NCAuthorOpinion: React.FC<NCAuthorOpinionProps> = ({ data }) => (
  <article className={clsx(styleUtils.nc, styles.container)}>
    <div className={styles.titleBox}>
      {data.image && (
        <AppImage image={data.image} layout="raw" sizes={48} className={styles.image} />
      )}
      <span className={styles.title}>{data.title}</span>
    </div>
    <div className={styles.contentBox}>
      <ul className={styles.numbers}>
        {data.numbers.map((number, index) => (
          <li key={index} className={styles.numbersOne}>
            <div className={styles.numbersIconWrapper}>
              <NumberInfoIcon icon={number.icon} className={styles.numbersIcon} />
            </div>
            <div className={styles.description}>
              <h3 className={styles.numbersTitle}>{number.title}</h3>
              {number.subTitle && <div className={styles.numbersSubTitle}>{number.subTitle}</div>}
            </div>
          </li>
        ))}
      </ul>
      <div className={styles.text}>{data.text}</div>
    </div>
  </article>
)

export default NCAuthorOpinion
